<div class="h-full w-full flex place-content-center place-items-center">
  <div
    [ngClass]="{ 'spinner-border-sm': size() === 'small' }"
    class="spinner-border"
    role="status"
  >
    <span class="sr-only">Loading...</span>
  </div>
</div>
